import { InjectionToken } from '@angular/core';
import { SpAttachmentConfig } from '../config/sp-attachment-config';

export const SpAttachmentConfigService = new InjectionToken<SpAttachmentConfig>(
    'TestLibConfig'
);
